import {
  createSearchParams,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import ConnectorPinsSection from '../../../../../components/dtcs/TATMappings/ConnectorMapping/ConnectorPinsSection'
import DTCMappingSection from '../../../../../components/dtcs/TATMappings/ConnectorMapping/DTCMappingSection'
import SelectConnectorSection from '../../../../../components/dtcs/TATMappings/ConnectorMapping/SelectConnectorSection'
import ConnectorPinsStore from '../../../../../components/dtcs/TATMappings/ConnectorMapping/context/context'
import { useContext } from 'react'
import { NavContext } from '../../../../../context/global_context'
import DtcsHeader from '../../../../../components/dtcs/TATMappings/DtcsHeader'

const TatConnectorMapping = () => {
  let { vehicle, connector_id } = useParams()
  const navigate = useNavigate()
  const [value] = useContext(NavContext)
  const [searchParams, setSearchParams] = useSearchParams()

  return (
    <ConnectorPinsStore>
      <>
        {value?.dtc_details?.length > 0 && (
          <DtcsHeader dtcs={value?.dtc_details} vehicleSid={value?.vehicle} />
        )}
        <div
          className="flex items-stretch flex-grow"
          style={{ height: '90vh' }}
        >
          <ConnectorPinsSection />
          <div className="flex-1 w-1/3 flex flex-col px-4 py-2 bg-tracer-darker-blue flex-grow">
            <SelectConnectorSection />
          </div>
          <DTCMappingSection />
        </div>
        <div className="flex justify-center">
          <input
            type="button"
            className={`cursor-pointer btn danger my-4 px-5`}
            style={{ width: 100 }}
            onClick={(e) =>
              navigate({
                pathname: `/vehicles/${vehicle}/dtcs/listing/mappings`,
                search: `?${createSearchParams({
                  dtc_id: searchParams.getAll('dtc_id'),
                  q: searchParams.get('q'),
                })}`,
              })
            }
            value="Cancel"
          />
        </div>
      </>
    </ConnectorPinsStore>
  )
}

export default TatConnectorMapping
